
import DivSpan from '@/components/DivSpan';
import fileUpload from '@/components/file-upload';
import dynamicApproval from './dynamic-approval';
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'

import selectSupply from '@/components/browse/select-supply';

export default {
name: "sup-info-approve",
props: ['dataId'],
components: {
DivSpan,
fileUpload,
dynamicApproval,
CheckIcon,
InlineXSwitch,
selectSupply
},
data() {
return {
gridList: [
{icon: require('@/assets/icon/supplier/supplier_base_data.png'), label: '基本信息'},
{icon: require('@/assets/icon/supplier/bidding_detail.png'), label: '变更信息'},
{icon: require('@/assets/icon/supplier/com_order_flow.png'), label: '流程信息'},
],
tabIndex: 1,
supModify: {},
supInfo: {},
baseModifyContent: [],
contactModifyContent: {},
contactVisible: false,
newContactObj: {},
oldContactObj: {},
bankVisible: false,
bankModifyContent: {},
newBankObj: {},
oldBankObj: {},
reservedCon1: null,
reservedCon2: null,
reservedCon3: null,
baseShow: false,
bankShow1: false,
bankShow2: false,
contactShow1: false,
contactShow2: false,
con1Show: false,
con2Show: false,
isSupplier: false,
con3Show: false,
qualVisible: false,
qualModifyContent: []
}
},
methods: {
valid() {
if (this.supModify.autoToErp && !this.supModify.erpWfPersonName) {
return false;
} else {
return true;
}
},
formData() {
return this.supModify;
},
changeIndex(index) {
this.tabIndex = index;
if (index === 3) {
this.$emit('changeFlowInfo', true);
} else {
this.$emit('changeFlowInfo', false);
}
},
changeShow(str) {
this[str] = !this[str];
},
getInfo() {
this.$loadingShow();
this.$get(`api/sup-modify/${this.dataId}`).then((res) => {
if (res) {
this.supModify = res;
this.supInfo = res.supplier;
for (let i = 0; i < this.supInfo.supModuleStatus.length; i++) {
if (this.supInfo.supModuleStatus[i].moduleName === 'BASIC_INFO') {
if (this.supInfo.supModuleStatus[i].modifyContent) {
if (JSON.parse(this.supInfo.supModuleStatus[i].modifyContent).changeList) {
this.baseModifyContent = JSON.parse(this.supInfo.supModuleStatus[i].modifyContent).changeList;
}
}
continue;
}
if (this.supInfo.supModuleStatus[i].moduleName === 'SUP_CONTACT') {
if (this.supInfo.supModuleStatus[i].modifyContent) {
this.contactModifyContent = JSON.parse(this.supInfo.supModuleStatus[i].modifyContent);
this.contactVisible = true;
this.newContactObj = {};
this.oldContactObj = {};
if (this.contactModifyContent.oldList) {
this.contactModifyContent.oldList.forEach((item) => {
this.oldContactObj[item.id] = item;
});
}
if (this.contactModifyContent.newList) {
this.contactModifyContent.newList.forEach((item) => {
this.newContactObj[item.id] = item;
});
}
}
continue;
}
if (this.supInfo.supModuleStatus[i].moduleName === 'SUP_BANK') {
if (this.supInfo.supModuleStatus[i].modifyContent) {
this.bankVisible = true;
this.bankModifyContent = JSON.parse(this.supInfo.supModuleStatus[i].modifyContent);
this.newBankObj = {};
this.oldBankObj = {};
if (this.bankModifyContent.oldList) {
this.bankModifyContent.oldList.forEach((item) => {
this.oldBankObj[item.id] = item;
});
}
if (this.bankModifyContent.newList) {
this.bankModifyContent.newList.forEach((item) => {
this.newBankObj[item.id] = item;
});
}
}
continue;
}
if (this.supInfo.supModuleStatus[i].moduleName == 'SUP_QUAL') {
if (this.supInfo.supModuleStatus[i].modifyContent) {
this.qualVisible = true;
this.qualModifyContent = JSON.parse(this.supInfo.supModuleStatus[i].modifyContent);
this.newQualObj = {};
this.oldQualObj = {};
if (this.qualModifyContent.oldList) {
this.qualModifyContent.oldList.forEach((item) => {
this.oldQualObj[item.id] = item;
});
}
if (this.qualModifyContent.newList) {
this.qualModifyContent.newList.forEach((item) => {
this.newQualObj[item.id] = item;
});
}
}
continue;
}
if (this.supInfo.supModuleStatus[i].moduleName === 'RESERVED_1') {
if (this.supInfo.supModuleStatus[i].modifyContent) {
this.reservedCon1 = JSON.parse(this.supInfo.supModuleStatus[i].modifyContent);
}
continue;
}
if (this.supInfo.supModuleStatus[i].moduleName === 'RESERVED_2') {
if (this.supInfo.supModuleStatus[i].modifyContent) {
this.reservedCon2 = JSON.parse(this.supInfo.supModuleStatus[i].modifyContent);
}
continue;
}
if (this.supInfo.supModuleStatus[i].moduleName === 'RESERVED_3') {
if (this.supInfo.supModuleStatus[i].modifyContent) {
this.reservedCon3 = JSON.parse(this.supInfo.supModuleStatus[i].modifyContent);
}
}
}
}
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
})
},
getIsSupplier() {
this.$get('api/person/current').then((res) => {
if (res.userType === '0') {
this.isSupplier = true;
} else {
this.isSupplier = false;
}
})
},
switchChange(e) {
this.supModify["autoToErp"] = e;
},

selectSupplier() {
if (this.supModify.requestBase && this.supModify.requestBase.workflowNodeBase && this.supModify.requestBase.workflowNodeBase.actNodeId == 'end') {
return
}
this.$refs.personRef.showPop();
},
getPerson(result) {
this.supModify["erpWfPersonId"] = result.id;
this.supModify["erpWfPersonName"] = result.name;
}
},
mounted() {
this.getInfo();
this.getIsSupplier();
}
}



// WEBPACK FOOTER //
// ./src/page/supplier/approval/sup-info-approve.vue